export const styles = {
  root: { display: "flex", justifyContent: "center", alignItems: "center" },
  card: {
    padding: { xs: "1.5rem", sm: "2rem" },
    border: "none",
    boxShadow: "none",
    display: "flex",
    flexDirection: "column",
    rowGap: "1rem",
    width: { xs: "95%", sm: "90%", md: "70rem" },
    maxHeight: { xs: "90vh", sm: "95vh" },
    overflowY: "auto",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  label: { mb: 0.5, fontWeight: 700, fontFamily: "Open Sans" },
  textField: {
    width: "100%",
    "& .MuiOutlinedInput-root.Mui-disabled": {
      backgroundColor: "shadesOfDark.ultraLight",
      "& > input": {
        WebkitTextFillColor: "shadesOfDark.steel",
      },
      "& .MuiOutlinedInput-notchedOutline": {
        borderColor: "shadesOfDark.light",
      },
    },
  },
};
